<template>
    <!-- 质量统计 -->
    <div class="animate__animated animate__fadeIn" id="myChart"
         style="width: 70%;height: 700px;margin: auto;margin-top:-2%;"></div>
</template>

<script>
    var that;
    import echarts from "echarts";
    import request from "@/utils/request";

    export default {
        name: "index",
        data() {
            return {
                labelopt: {
                    show: true,
                    position: "insideBottom",
                    distance: 15,
                    align: "left",
                    verticalAlign: "middle",
                    rotate: 90,
                    formatter: "{c}  {name|{a}}",
                    fontSize: 16,
                    rich: {
                        name: {
                            textBorderColor: "#fff"
                        }
                    }
                },
                inner_data: [],
                outer_data: [],
                myChart:null
            };
        },

        created: function () {
            // 获取所有区域
            that = this;
        },
        mounted() {
            that.fnGetMapData();
            window.addEventListener('resize', this.chartResize);
        },
        beforeDestroy() {
        },
        methods: {
            chartResize() {
                this.myChart.resize();
            },
            // 获取今日考勤数据
            fnGetMapData() {
                request({
                    url: "getQMapData",
                    method: "GET"
                })
                    .then(res => {
                        if (res.data) {
                            let Data = res.data;
                            for (let _key in Data) {
                                let total = 0;
                                let type = '';
                                for (let idx in Data[_key]) {
                                    if (idx == 'type') {
                                        type = Data[_key][idx];
                                    } else {
                                        //总数
                                        total += Data[_key][idx];
                                        //组装外层数据  {value: 1, name: '整改中'},
                                        Data[_key][idx] && that.outer_data.push({value: Data[_key][idx], name: that.getHandleName(idx,Data[_key]['type'])});
                                    }
                                }
                                //组装内层数据
                                that.inner_data.push({name: type, value: total});
                            }
                            that.drawLine();
                        }
                    })
                    .catch(err => {
                        this.$message.error(err.data);
                    });
            },
            getHandleName(name,type) {
                switch (name) {
                    case 'ing_count':
                        return '('+type+')'+' 整改中';
                    case 'not_count':
                        return '('+type+')'+' 未整改';
                    case 'time_count':
                        return '('+type+')'+' 准时整改';
                    case 'timeout_count':
                        return '('+type+')'+' 超时整改';
                }
            },
            // 初始化统计图
            drawLine() {
                // 基于准备好的dom，初始化echarts实例
                this.myChart = this.$echarts.init(document.getElementById("myChart"));
                // 绘制图表
                this.myChart.setOption({
                    title: {
                        text: "质量统计",
                        x: "center",
                        y: 85,
                        textStyle: {
                            color: "#B4B4B4",
                            fontSize: 20,
                            fontWeight: "normal"
                        }
                    },
                    tooltip: {
                        trigger: 'item',
                        formatter: '{b} : <br/>数量 : <b>{c}</b>条<br/>占比 : ({d}%)'
                    },
                    series: [{
                        name: '巡检类别:',
                        type: 'pie',
                        selectedMode: 'single',
                        radius: [0, '35%'],
                        label: {
                            position: 'inner'
                        },
                        labelLine: {show: false},
                        data: this.inner_data
                    },
                        {
                            type: 'pie',
                            selectedMode: 'single',
                            radius: ['45%', '60%'],
                            label: {
                                formatter: '  {b|{b}：}{c|{c}}  {per|{d}%}  ',
                                backgroundColor: '#eee',
                                borderColor: '#aaa',
                                borderWidth: 1,
                                borderRadius: 4,
                                rich: {
                                    b: {
                                        fontSize: 16,
                                        lineHeight: 33
                                    },
                                    c:{
                                        fontSize: 16
                                    },
                                    per: {
                                        color: '#eee',
                                        backgroundColor: '#334455',
                                        padding: [2, 4],
                                        borderRadius: 2
                                    }
                                }
                            },
                            data: this.outer_data
                        }
                    ],
                });
            }
        }
    };
</script>

<style>
    #myChart >>> div {
        margin: auto;
    }
</style>



// WEBPACK FOOTER //
// src/views/Quality/qualityDefault/index.vue